import React from 'react';

export function Logo({ className = "h-10", light = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto"
      >
        <path
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          fill={light ? "white" : "#047857"} // emerald-700
          className="transition-colors duration-300"
        />
        <path
          d="M12 22C12 22 12 18 16 14C20 10 22 10 22 10"
          stroke={light ? "white" : "#047857"}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M12 22C12 22 12 18 8 14C4 10 2 10 2 10"
          stroke={light ? "white" : "#047857"}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <span className={`font-bold text-xl tracking-tight ${light ? 'text-white' : 'text-emerald-900'}`}>
        DK Grøn <span className={light ? 'text-emerald-200' : 'text-emerald-600'}>Service</span>
      </span>
    </div>
  );
}
